module.exports = __webpack_public_path__ + "static/media/isem.fd45a5cc.png";